export type ReplaceExpertInputType = {
  expertId?: number;
  reason?: string;
};

export const badgeStyle = {
  color: 'gray',
  right: '-2px',
  top: '-8px',
};

export type ExpertiseLoadingStatusType = {
  status: 'loading' | 'neutral';
  id?: number;
};
